exports = module.exports = require("../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".log-container .el-collapse-item__arrow {\n  margin-left: 6px;\n}", ""]);

// exports
